import React, { useContext, useState } from 'react';

import * as S from './styles';
import BulletPoint from '../../../../../components/newStudent/BulletPoint';
import ButtonOpen from '../../../../../components/newStudent/Buttons/ButtonOpen';
import TableBasic, {
  ITableData,
} from '../../../../../components/newStudent/Table';
import { useTheme } from 'styled-components';
import { handleMaxWidth } from '../../../../../util/newStudent';
import TableCollapseTitle from '../TableCollapseTitle';
import {
  IDisciplineGardesShow,
  myGradesServiceNewStudent,
} from '../../../../../services/newStudent/myGrades/myGrades.service';
import {
  IGradeInterfaceMobile,
  ICollapseGradesProps,
} from '../../../../../types/newStudent/myGrades.interface';
import {
  INewStudentProvider,
  NewStudentProviderContext,
} from '../../../../../components/newStudent/ProviderNewStudent';

export type { IGradeActivityItem, IGradeInterfaceMobile } from '../../../../../types/newStudent/myGrades.interface';

export default function CollapseGrades({ item, isOpen, setIsOpen }: ICollapseGradesProps) {
  const { setIsLoading } = useContext(
    NewStudentProviderContext,
  ) as INewStudentProvider;

  const [data, setData] = useState<IDisciplineGardesShow[]>();

  const theme = useTheme();

  const handleClick = () => {
    const fetch = async () => {
      try {
        setIsLoading(true);
        const { result, data } = await myGradesServiceNewStudent.grades(
          item.id,
        );
        if (result) {
          setData(data);

          isOpen !== item.id ? setIsOpen(item.id) : setIsOpen(undefined);
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  };

  const statusEnum = {
    Pendente: {
      color: theme.colors?.text.secondary,
      status: 'Pendente',
    },
    'Em Andamento': {
      color: theme.colors?.text.info01,
      status: 'Em Andamento',
    },
    'Em Recuperação': {
      color: theme.colors?.warning,
      status: 'Em Recuperação',
    },
    Aprovado: { color: theme.colors?.text.success, status: 'Aprovado' },
    Dispensado: { color: theme.colors?.text.success, status: 'Dispensado' },
    Reprovado: { color: theme.colors?.text.danger, status: 'Reprovado' },
  };

  const dataTable: ITableData[] =
    data?.map((grade) => ({
      title: [
        {
          item: <S.Title>{grade.moduleName.toUpperCase()}</S.Title>,
        },
        { item: <S.TitleSmall>Nota</S.TitleSmall>, align: 'center' },

        {
          item: <S.TitleSmall>Situação</S.TitleSmall>,
          align: 'center',
        },
      ],
      content: grade.disciplines.map((itemGrade) => ({
        discipline: {
          item: (
            <S.DivDiscipline>
              <S.Name>{itemGrade.disciplineName.toUpperCase()}</S.Name>
            </S.DivDiscipline>
          ),
        },
        grade: {
          item: (
            <S.GradeCell>
              <S.Grade>{itemGrade.grade}</S.Grade>
              {itemGrade.activities && itemGrade.activities.length > 0 && (
                <S.ActivitiesList>
                  {itemGrade.activities.map((act) => (
                    <S.ActivityItem key={act.activityId}>
                      <S.ActivityName>{act.activityName}</S.ActivityName>
                      <S.ActivityGrade>{act.grade != null ? String(act.grade) : '-'}</S.ActivityGrade>
                    </S.ActivityItem>
                  ))}
                </S.ActivitiesList>
              )}
            </S.GradeCell>
          ),
          align: 'center',
        },
        situation: {
          align: 'center',
          item: (
            <S.H6
              style={{
                color: statusEnum[itemGrade.status].color,
              }}
            >
              {statusEnum[itemGrade.status].status}
            </S.H6>
          ),
        },
      })),
    })) ?? [];

  const dataTableMobile: IGradeInterfaceMobile[] =
    data?.map((grade: IDisciplineGardesShow) => ({
      title: `${grade.moduleName.toUpperCase()}`,
      grades: grade.disciplines.map((itemGrade) => ({
        discipline: itemGrade.disciplineName.toUpperCase(),
        grade: itemGrade.grade,
        situation: itemGrade.attempt,
        status: statusEnum[itemGrade.status].status,
        color: statusEnum[itemGrade.status].color,
        activities: itemGrade.activities?.map((a) => ({
          activityName: a.activityName,
          grade: a.grade,
          weight: a.weight,
        })),
      })),
    })) ?? [];

  return (
    <S.Container>
      <BulletPoint
        color="success"
        buttons={
          <ButtonOpen
            widthSize={
              theme.fontSizeType == 'large' || theme.fontSizeType == 'xLarge'
                ? 'large'
                : 'xmedium'
            }
            title="Ver Notas"
            titleClose="Fechar"
            open={isOpen === item.id}
            onClick={() => {
              if (isOpen !== item.id) {
                handleClick();
              } else {
                setIsOpen(undefined);
              }
            }}
          />
        }
        flexDirection={handleMaxWidth(theme.size?.medium) ? 'column' : 'row'}
      >
        {item.courseName}
      </BulletPoint>
      {isOpen === item.id && (
        <S.ContentFocus>
          {handleMaxWidth(theme.size?.medium)
            ? dataTableMobile.map((grade, index) => (
                <TableCollapseTitle key={index} data={grade} />
              ))
            : dataTable.map((grade, index) => (
                <S.Table key={index}>
                  <TableBasic data={grade} />
                </S.Table>
              ))}
        </S.ContentFocus>
      )}
    </S.Container>
  );
}
